import styled from 'styled-components/macro';


export const StyledArrow = styled.span`
   
`;

